import React, { useState } from 'react';
import { Link } from 'react-router-dom';

function WorkbookGetStarted() {
  const [email, setEmail] = useState('');
  const [name, setName] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();
    // Here you would integrate with your payment processor (Stripe, PayPal, etc.)
    alert('Payment integration would go here! This is a demo.');
  };

  return (
    <div className="min-h-screen bg-gradient-to-b from-cream-50 to-white">
      {/* Header */}
      <section className="pt-32 pb-16 px-6">
        <div className="max-w-5xl mx-auto">
          <Link to="/workbook" className="inline-flex items-center text-cream-700 hover:text-cream-800 mb-8 transition-colors">
            <svg className="w-5 h-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
            </svg>
            Back to Workbook
          </Link>
          
          <div className="text-center mb-12">
            <h1 className="text-4xl md:text-5xl font-light text-charcoal mb-4">
              Get Your Workbook
            </h1>
            <p className="text-lg text-charcoal/70">
              One-time payment • Instant download • Lifetime access
            </p>
          </div>
        </div>
      </section>

      {/* Main Content */}
      <section className="px-6 pb-20">
        <div className="max-w-5xl mx-auto">
          <div className="grid lg:grid-cols-2 gap-12">
            {/* Left Column - What You Get */}
            <div>
              <h2 className="text-3xl font-light text-charcoal mb-6">
                What You're Getting
              </h2>
              
              <div className="bg-white rounded-2xl shadow-lg p-8 mb-6">
                <div className="flex items-center justify-between mb-6 pb-6 border-b border-gray-200">
                  <h3 className="text-2xl font-medium text-charcoal">Boundary Reset Workbook</h3>
                  <span className="text-3xl font-semibold text-cream-600">$29</span>
                </div>
                
                <ul className="space-y-4 mb-8">
                  <li className="flex items-start gap-3">
                    <svg className="w-6 h-6 text-cream-600 flex-shrink-0 mt-1" fill="currentColor" viewBox="0 0 20 20">
                      <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
                    </svg>
                    <div>
                      <span className="font-medium text-charcoal">4 Comprehensive Modules</span>
                      <p className="text-sm text-charcoal/70">Understanding boundaries, working through guilt, practical scripts, and progress tracking</p>
                    </div>
                  </li>
                  
                  <li className="flex items-start gap-3">
                    <svg className="w-6 h-6 text-cream-600 flex-shrink-0 mt-1" fill="currentColor" viewBox="0 0 20 20">
                      <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
                    </svg>
                    <div>
                      <span className="font-medium text-charcoal">50+ Actionable Exercises</span>
                      <p className="text-sm text-charcoal/70">Reflections, assessments, and practice scenarios</p>
                    </div>
                  </li>
                  
                  <li className="flex items-start gap-3">
                    <svg className="w-6 h-6 text-cream-600 flex-shrink-0 mt-1" fill="currentColor" viewBox="0 0 20 20">
                      <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
                    </svg>
                    <div>
                      <span className="font-medium text-charcoal">Ready-to-Use Scripts</span>
                      <p className="text-sm text-charcoal/70">For work, family, friends, and relationships</p>
                    </div>
                  </li>
                  
                  <li className="flex items-start gap-3">
                    <svg className="w-6 h-6 text-cream-600 flex-shrink-0 mt-1" fill="currentColor" viewBox="0 0 20 20">
                      <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
                    </svg>
                    <div>
                      <span className="font-medium text-charcoal">Bonus Resources</span>
                      <p className="text-sm text-charcoal/70">Quick reference guide, affirmation cards, guided meditation, and more</p>
                    </div>
                  </li>
                  
                  <li className="flex items-start gap-3">
                    <svg className="w-6 h-6 text-cream-600 flex-shrink-0 mt-1" fill="currentColor" viewBox="0 0 20 20">
                      <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
                    </svg>
                    <div>
                      <span className="font-medium text-charcoal">Lifetime Access</span>
                      <p className="text-sm text-charcoal/70">Download once, access forever + free future updates</p>
                    </div>
                  </li>
                </ul>
                
                <div className="bg-cream-50 p-4 rounded-xl">
                  <div className="flex items-center gap-2 mb-2">
                    <svg className="w-5 h-5 text-cream-600" fill="currentColor" viewBox="0 0 20 20">
                      <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
                    </svg>
                    <span className="font-medium text-charcoal">100% Satisfaction Guarantee</span>
                  </div>
                  <p className="text-sm text-charcoal/70">
                    If you're not satisfied within 30 days, I'll refund your purchase—no questions asked.
                  </p>
                </div>
              </div>
              
              {/* Trust Badges */}
              <div className="flex items-center gap-8 justify-center text-charcoal/60">
                <div className="flex items-center gap-2">
                  <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" />
                  </svg>
                  <span className="text-sm">Secure Payment</span>
                </div>
                <div className="flex items-center gap-2">
                  <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" />
                  </svg>
                  <span className="text-sm">Privacy Protected</span>
                </div>
              </div>
            </div>

            {/* Right Column - Checkout Form */}
            <div>
              <div className="bg-white rounded-2xl shadow-lg p-8 sticky top-24">
                <h2 className="text-2xl font-light text-charcoal mb-6">
                  Complete Your Purchase
                </h2>
                
                <form onSubmit={handleSubmit} className="space-y-6">
                  <div>
                    <label htmlFor="name" className="block text-sm font-medium text-charcoal mb-2">
                      Full Name
                    </label>
                    <input
                      type="text"
                      id="name"
                      value={name}
                      onChange={(e) => setName(e.target.value)}
                      required
                      className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-cream-500 focus:border-transparent"
                      placeholder="Jane Smith"
                    />
                  </div>
                  
                  <div>
                    <label htmlFor="email" className="block text-sm font-medium text-charcoal mb-2">
                      Email Address
                    </label>
                    <input
                      type="email"
                      id="email"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                      required
                      className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-cream-500 focus:border-transparent"
                      placeholder="jane@example.com"
                    />
                    <p className="text-xs text-charcoal/60 mt-1">
                      We'll send your workbook to this email
                    </p>
                  </div>
                  
                  <div className="bg-cream-50 p-4 rounded-lg">
                    <div className="flex justify-between items-center mb-2">
                      <span className="text-charcoal/70">Subtotal</span>
                      <span className="text-charcoal">$29.00</span>
                    </div>
                    <div className="flex justify-between items-center pt-2 border-t border-cream-200">
                      <span className="font-medium text-charcoal">Total</span>
                      <span className="text-2xl font-semibold text-charcoal">$29.00</span>
                    </div>
                  </div>
                  
                  <div className="space-y-3">
                    <button
                      type="submit"
                      className="w-full bg-cream-600 text-white py-4 rounded-full text-lg font-medium hover:bg-cream-700 transition-all duration-300 shadow-lg hover:shadow-xl"
                    >
                      Complete Purchase
                    </button>
                    
                    <div className="text-center">
                      <p className="text-xs text-charcoal/60">
                        By purchasing, you agree to our terms and conditions
                      </p>
                    </div>
                  </div>
                </form>
                
                <div className="mt-6 pt-6 border-t border-gray-200">
                  <h3 className="font-medium text-charcoal mb-3 text-sm">What happens next?</h3>
                  <ol className="space-y-2 text-sm text-charcoal/70">
                    <li className="flex gap-2">
                      <span className="font-medium text-cream-600">1.</span>
                      <span>Complete secure payment</span>
                    </li>
                    <li className="flex gap-2">
                      <span className="font-medium text-cream-600">2.</span>
                      <span>Receive instant download link via email</span>
                    </li>
                    <li className="flex gap-2">
                      <span className="font-medium text-cream-600">3.</span>
                      <span>Start your boundary journey today!</span>
                    </li>
                  </ol>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* FAQ Section */}
      <section className="px-6 py-20 bg-cream-50">
        <div className="max-w-4xl mx-auto">
          <h2 className="text-3xl font-light text-charcoal text-center mb-12">
            Common Questions
          </h2>
          
          <div className="grid md:grid-cols-2 gap-6">
            <div className="bg-white p-6 rounded-xl">
              <h3 className="font-medium text-charcoal mb-2">When do I get access?</h3>
              <p className="text-sm text-charcoal/70">
                Immediately after purchase! You'll receive an email with your download link within minutes.
              </p>
            </div>
            
            <div className="bg-white p-6 rounded-xl">
              <h3 className="font-medium text-charcoal mb-2">What format is it?</h3>
              <p className="text-sm text-charcoal/70">
                The workbook is a PDF you can print or fill out digitally. Bonus audio files are in MP3 format.
              </p>
            </div>
            
            <div className="bg-white p-6 rounded-xl">
              <h3 className="font-medium text-charcoal mb-2">Can I share it?</h3>
              <p className="text-sm text-charcoal/70">
                The workbook is for personal use only. Please don't share or redistribute it.
              </p>
            </div>
            
            <div className="bg-white p-6 rounded-xl">
              <h3 className="font-medium text-charcoal mb-2">What's your refund policy?</h3>
              <p className="text-sm text-charcoal/70">
                100% money-back guarantee within 30 days if you're not satisfied. Just email me!
              </p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}

export default WorkbookGetStarted;
